// Les comptes publics de Provena, en un seul endroit côté navigateur.
//
// La même adresse existe aussi dans deux fichiers que ce module ne peut pas
// atteindre : index.html, qui est hors du bundle, et emails.py, qui tourne dans
// un autre langage. Ces trois copies sont vérifiées l'une contre l'autre par
// des tests, plutôt que laissées à la vigilance : une adresse sociale qui
// diverge ne tombe pas en panne, elle mène ailleurs.
export const INSTAGRAM_URL = "https://www.instagram.com/provenaregistry/";
